<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-truck mr-2" />Daftar Layanan Pengiriman
            </h5>
            <hr />
            <b-row>
                <b-col xs="12" sm="8" md="6" lg="5" xl="4">
                    <b-form-group label="Nama Layanan">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button
                            variant="primary"
                            :disabled="isBusy"
                            @click="getItems()"
                        >
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
                class="mb-3"
                id="local-table"
                :current-page="currentPage"
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty> Tidak ada data admin. </template>
                <template v-slot:cell(name)="row">
                    <span>{{ row.item.courier_name }}</span
                    ><br />
                    <small class="text-muted">{{
                        row.item.courier_service_name
                    }}</small>
                </template>
                <template v-slot:cell(duration)="row">
                    <span>{{
                        row.item.shipment_duration_range +
                        " " +
                        row.item.shipment_duration_unit
                    }}</span
                    ><br />
                    <small class="text-muted">{{
                        row.item.service_type
                    }}</small>
                </template>
                <template v-slot:cell(is_active)="row">
                    <b-badge variant="success" v-if="row.item.is_active == 1"
                        >Aktif</b-badge
                    >
                    <b-badge variant="danger" v-else>Nonaktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <!-- <b-button
                        size="sm"
                        class="ml-2"
                        :variant="
                            row.item.is_active == 1 ? 'danger' : 'success'
                        "
                        v-b-tooltip.hover.top
                        :title="
                            row.item.is_active == 1 ? 'Nonaktifkan' : 'Aktifkan'
                        "
                        :disabled="
                            (row.item.role_id == 1 &&
                                row.item.is_active == 1) ||
                            isBusy ||
                            isSubmitting
                        "
                        @click="confirmToggle(row.item)"
                    >
                        <i class="fa fa-fw fa-power-off" />
                    </b-button> -->
                    <b-form-checkbox
                        class="switch-active"
                        v-model="row.item.is_active"
                        @change="confirmToggle(row.item)"
                        switch
                        size="md"
                    ></b-form-checkbox>
                </template>
            </b-table>

            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isFilter: false,
            isBusy: true,
            isSubmitting: false,

            filter: {
                name: "",
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                { key: "name", label: "Nama Layanan", sortable: true },
                { key: "description", label: "Deskripsi", sortable: true },
                { key: "duration", label: "Lama Pengiriman", sortable: true },
                { key: "is_active", label: "Status", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],

            items: [],
            filteredItems: [],

            currentPage: 1,
            pageLength: 0,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        confirmToggle(item) {
            let action = !item.is_active ? "nonaktif" : "aktif";

            // let isConfirmed = confirm(
            //     "Apakah anda yakin ingin meng" +
            //         action +
            //         "kan Layanan Pengiriman " +
            //         item.courier_name +
            //         " " +
            //         item.courier_service_name +
            //         "?"
            // );
            // if (!isConfirmed) return;

            // this.isSubmitting = true;

            let payload = {
                id: item.id,
                isActive: item.is_active ? "true" : "false",
            };

            this.$axios
                .post("admin/shipping/setStatusCouriers", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Layanan pengiriman " +
                            item.courier_name +
                            " berhasil di" +
                            action +
                            "kan!"
                    );
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page) || page === undefined) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            // let param = this.$helper.getBasePagedQuery(
            //     this.currentPage,
            //     this.perPage
            // );

            const payload = {
                page: this.currentPage,
                perPage: this.perPage,
                courier_name: this.filter.name || "",
                sortBy: this.sortBy || "id",
                sortDesc: this.sortDesc,
            };

            return this.$axios
                .get(
                    `admin/shipping/getAllCouriers?page=${
                        payload.page
                    }&perPage=${payload.perPage}&courier_name=${
                        payload.courier_name
                    }&sortBy=${
                        payload.sortBy === "name"
                            ? "courier_name"
                            : payload.sortBy === "duration"
                            ? "shipment_duration_range"
                            : payload.sortBy
                    }&sortDesc=${payload.sortDesc}`
                )
                .then((res) => {
                    const data = res.data.data;
                    this.totalRows = data.total;
                    this.items = data.items.map((item) => {
                        return {
                            ...item,
                            is_active: item.is_active === 1 ? true : false,
                        };
                    });
                    this.filteredItems = data.items.map((item) => {
                        return {
                            ...item,
                            is_active: item.is_active === 1 ? true : false,
                        };
                    });
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        onFilterChanged(items) {
            this.isFilter = true;
            this.filteredItems = items;
        },
    },

    created() {
        this.init();
    },
};
</script>
